import $ from 'jquery';
import {showAddedCartToast, showCartProductAmountChanged, showDeletedFromCartToast} from './toast-mustache-template';

/* jQuery.cookie.min.js */
// eslint-disable-next-line
(function(e){e($)})(function(e){function n(e){return u.raw?e:encodeURIComponent(e)}function r(e){return u.raw?e:decodeURIComponent(e)}function i(e){return n(u.json?JSON.stringify(e):String(e))}function s(e){if(e.indexOf('"')===0){e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,'\\')}try{e=decodeURIComponent(e.replace(t,' '));return u.json?JSON.parse(e):e}catch(n){}}function o(t,n){var r=u.raw?t:s(t);return e.isFunction(n)?n(r):r}var t=/\+/g;var u=e.cookie=function(t,s,a){if(s!==undefined&&!e.isFunction(s)){a=e.extend({},u.defaults,a);if(typeof a.expires==='number'){var f=a.expires,l=a.expires=new Date;l.setTime(+l+f*864e5)}return document.cookie=[n(t),'=',i(s),a.expires?'; expires='+a.expires.toUTCString():'',a.path?'; path='+a.path:'',a.domain?'; domain='+a.domain:'',a.secure?'; secure':''].join('')}var c=t?undefined:{};var h=document.cookie?document.cookie.split('; '):[];for(var p=0,d=h.length;p<d;p++){var v=h[p].split('=');var m=r(v.shift());var g=v.join('=');if(t&&t===m){c=o(g,s);break}if(!t&&(g=o(g))!==undefined){c[m]=g}}return c};u.defaults={};e.removeCookie=function(t,n){if(e.cookie(t)===undefined){return false}e.cookie(t,'',e.extend({},n,{expires: -1}));return!e.cookie(t)}})

import 'jquery-colorbox';
import '../vendor/glDatePicker';

import * as feather from 'feather-icons';

/* eslint-disable eqeqeq, no-mixed-spaces-and-tabs */

var timeout = 200,
    limit_units = 0,
    limit_total = 0,
    limit_days = 0,
    limit_total_warning = '',
    limit_units_warning = '',
    limit_days_warning = '';

function renderCart(model, cartData) {

    /* Render sidebar cart */
    if(model === 'sideCart') {

        var $cartTotal = $('#cartTotal');

        if(cartData.length>0) {
            var cart_info = cartData[1].cart_info;
            $cartTotal.fadeOut(0);
            $cartTotal.find('.totalSum').empty();
            $cartTotal.find('.totalSum').append(cart_info.total_price +' €');
            $cartTotal.find('a.orderButton').removeClass('disabled');
            $cartTotal.fadeIn(timeout);
        } else {
            $cartTotal.fadeOut(0);
            $cartTotal.find('.totalSum').empty();
            $cartTotal.find('.totalSum').append('0 €');
            $cartTotal.find('a.orderButton').addClass('disabled');
            $cartTotal.fadeIn(timeout);
        }
    }

    /* Render summary cart */
    if(model === 'summary') {

        var $tableSummary = $('.orderSummary')

        if(cartData.length>0) {
            let cart_info = cartData[1].cart_info;

            $('.loadingCart').fadeIn();

            var url = '/fi/verkkokauppa/ajax-pages/kori/'; // /stage-ajax/getCartSUmmary

            $.get(url, function(data) {
                if(cart_info.total_amount === 0) {
                    window.location.reload();
                } else {
                    $tableSummary.html(data);
                    feather.replace();
                }
            });
            if(cart_info.total_price) {
                if(limit_total > 0) {
                    if(parseFloat(cart_info.total_price) > limit_total && $.cookie('finnsweet_shop_limit_total') != '1') {
                        alert(limit_total_warning)
                        $.cookie('finnsweet_shop_limit_total', '1', { expires: 1, path: '/' });
                    }
                }
            }
            $tableSummary.fadeIn(timeout);
        }
    }
}


/* When click amount box, select all */
function initialize() {

    if($('body').data('limit_days') > 0) {
        limit_days = parseFloat($('body').data('limit_days'));
    }
    if($('body').data('limit_total') >0) {
        limit_total = parseFloat($('body').data('limit_total'));
    }
    if($('body').data('limit_units') >0) {
        limit_units = parseFloat($('body').data('limit_units'));
    }
    limit_total_warning = 'Tilauksen veroton loppusumma ylitti hälytysrajan: ' + limit_total + ' €.';
    limit_units_warning = 'Rivin yksikkömäärä ylitti hälytysrajan: ' + limit_units + ' yksikköä / rivi.';
    limit_days_warning = 'Tilauksen toimituspäivämäärä on yli hälytysrajan, toimitus yli ' + limit_days + ' päivän päässä.';

    $('body').on('click', '.updateProduct .customerPrice', function() {
        var customerPrice = prompt('Anna tuotteelle suositushinta',$(this).val());
        if (customerPrice != null) {
            var $thisForm = $(this).closest('.updateProduct');
            var product_id = $thisForm.find('input[name="product_id"]').val();
            var product_id_finnsweet = $thisForm.find('input[name="product_id_finnsweet"]').val();
            var amount = $thisForm.find('input[name="amount"]').val();
            //var unit = $thisForm.find('input[name="units"]').val();
            var product_ean = $thisForm.find('input[name="ean_code"]').val();
            var order = $thisForm.find('input[name="order"]').val();
            var title = $thisForm.find('input[name="product_title"]').val();
            var ajaxurl = $thisForm.find('input[name="ajaxurl"]').val();

            var removeItem = ajaxurl +'?action=change&product_id='+product_id+'&amount=0';
            $('.loadingCart').fadeIn();
            // Remove item with old parameters
            $.get(removeItem, function(data) {
                // When item is deleted, add it again with new parameters

                var addItem = ajaxurl +
                              '?action=add&product_id='+encodeURIComponent(product_id)+
                              '&title='+encodeURIComponent(title)+
                              '&order='+encodeURIComponent(order)+
                              '&ean='+encodeURIComponent(product_ean)+
                              '&customer_price='+encodeURIComponent(customerPrice)+
                              '&amount='+encodeURIComponent(amount)+
                              '&product_id_finnsweet='+encodeURIComponent(product_id_finnsweet);
                $.get(addItem, function(data) {
                    renderCart('summary', data);
                    //var updateCart = data[1].cart_info;
                });
            });

            $(this).val(customerPrice);
        }
        //$(this).select();
    });


    /* Disable enter key */
    $('body').on('keypress', 'form.changeAmount .amount', function (evt) {
        var charCode = evt.charCode || evt.keyCode;
        if (charCode == 13) { //Enter key's keycode
            $('.amount').focus();
        }
    });

    /* Change amount */
    $('body').on('submit', 'form.changeAmount', function(event) {
        event.preventDefault();
        const $thisForm = $(this).parent();

        const product_id = $thisForm.find('input[name="product_id"]').val();
        const product_title = $thisForm.find('input[name="product_title"]').val();
        const product_ean = $thisForm.find('input[name="product_ean"]').val();
        const amount = $thisForm.find('input[name="amount"]').val();
        const ajaxurl = $thisForm.find('input[name="ajaxurl"]').val();

        showCartProductAmountChanged({
            product_title,
            product_ean,
            amount
        })

        const url = ajaxurl +'?action=change&product_id='+product_id+'&amount='+amount;
        $('.loadingCart').fadeIn();
        $.get(url, function(data) {
            renderCart('summary', data);
        });
    });

    $('body').on('click', '.price.editable', function(event) {

        var $this =             $(this),
            originalPrice =     $this.data('originalprice'),
            productName =      $this.data('productname'),
            currentPrice =      $this.data('currentprice'),
            productid =         $this.data('productid'),
            message = 'Aseta tuotteelle "'+ productName +'" uusi verollinen hinta per myyntierä muodossa xx,xx\n\nAlkuperäinen hinta on '+ originalPrice +' € / Myyntierä\n\nJos haluat palauttaa alkuperäisen hinnan, aseta hinnaksi 0\n\n',
            url = '/fi/verkkokauppa/ajax-pages/set-manual-price/';

        var newPrice = prompt(message, currentPrice);
        if(newPrice != null) {
            newPrice.replace(/[€e ]+/g, '');

            $.get(url + '?id=' +productid + '&price=' + newPrice, function(data) {
                if(data.status == 1) {
                    $('.loadingCart').fadeIn();
                    $.get('/fi/verkkokauppa/ajax-pages/ajax--updatecart/', function(data) {
                        renderCart('summary', data);
                        //var updateCart = data[1].cart_info;
                    });

                    //alert('Uusi hinta on: ' + newPrice);
                } else {
                    alert('Hinnan asettaminen epäonnistui');
                }
            });
        }
    });

    /* Clearing the cart */
    $('body').on('submit', '.cartSummary form.emptyCart', function(event) {
        event.preventDefault();

        var $thisForm = $(this).parent();

        var empty = $thisForm.find('input[name="empty"]').val();
        var ajaxurl = $thisForm.find('input[name="ajaxurl"]').val();
        var url = ajaxurl +'?action=empty&empty='+empty;

        $.get(url, function(data) {
            /* Clear cookies of limits */
            $.each($.cookie(), function(key,value) {
                if(key.indexOf('finnsweet_shop') > -1) {
                    $.cookie(key, '0', { exprires: 1, path: '/' });
                }
            });

            location.reload();
        });

    });


    /* Shopping history, show order items */
    $('body').on('click', 'table tr.itemRow td.toggle', function(event) {
        var order_pid = $(this).parent().data('pid');
        if (order_pid > 0) {
            $('table tr.order-'+order_pid).toggleClass('show', 200);
        }
    });

    /* Search shopping history, clear input */
    $('input.searchWord').focus(function() {
        if ( $(this).val() === 'Hae asiakkaan nimellä...') {
            $(this).val('');
        }
    });
    $('input.searchWord').focusout(function() {
        if ( $(this).val() === '') {
            $(this).val('Hae asiakkaan nimellä...');
        }
    });

    /* Open bigger image of item */
    $('body').on('click', 'img.itemImg,img.mail-image-img', function(event) {
        event.preventDefault();

        $(this).closest('.itemBody').find('.itemBigImage').fadeIn(timeout);
    });

    /* Close bigger image of item */
    $('body').on('click', '.itemBigImage', function(event){
        event.preventDefault();
        $(this).fadeOut(timeout);
    });

    /* Adding item to cart
    *  No idea if this is even in use
    */
    $('body').on('submit', 'form.addItemPopup', function(event) {

        event.preventDefault();

        var product_id = $(this).find('input[name="product_id"]').val();
        var product_title = $(this).find('input[name="product_title"]').val();
        var product_ean = $(this).find('input[name="product_ean"]').val();
        var amount = $(this).find('input[name="amount"]').val();
        var ajaxurl = $(this).find('input[name="ajaxurl"]').val();
        var recommended_price = $(this).find('input[name="recommended_price"]').val();

        var submitButton = $(this).find('input.button');
        submitButton.attr('disabled', true);
        $('.updatingCart').fadeIn(timeout);

        showAddedCartToast({product_title, product_ean, amount, recommended_price });

        var url = ajaxurl +'?action=add&product_id='+encodeURIComponent(product_id)+
            '&title='+encodeURIComponent(product_title)+
            '&ean='+encodeURIComponent(product_ean)+
            '&amount='+encodeURIComponent(amount)+
            '&recommended_price='+encodeURIComponent(recommended_price);

        $.get(url, function(data) {
            renderCart('cartBlock', data);
            renderCart('sideCart', data);

            var updateCart = data[0].products;
            $.each(updateCart, function( key, value ) {
                var addedItem = updateCart[key].product_id;
                var addedItemQty = updateCart[key].amount;

                if(addedItem == product_id) {
                    if(parseFloat(addedItemQty) > limit_units && $.cookie('finnsweet_shop_' + product_id + '_limit_units') != '1') {
                        alert(limit_units_warning);
                        $.cookie('finnsweet_shop_' + product_id + '_limit_units', '1', { expires: 1, path: '/' });
                    }
                }
            });

            $('.updatingCart').fadeOut(timeout);
            submitButton.attr('disabled', false);
        });
        $.colorbox.close();
    });

    /*
    * Hiding products
    * No idea if this is even in use
    *
    */
    $('body').on('submit', 'form.hideItem', function(event) {
        event.preventDefault();

        var product_id = $(this).find('input[name="product_id"]').val();
        var user_id = $(this).find('input[name="user_id"]').val();
        var $action = $(this).find('input[name="action"]')
        var action = $action.val();
        var ajaxurl = $(this).find('input[name="ajaxurl"]').val();

        var submitButton = $(this).find('button[type="submit"]');
        submitButton.attr('disabled', true);

        var url = ajaxurl + '?user_id=' + user_id + '&product_id=' + product_id + '&action=' + action;

        $.get(url, function(data) {
            	if(data == '1') {
            		if(action == 'show') {
            			submitButton.text('Piilota tuote');
            			$action.val('hide');
            		} else {
            			submitButton.text('Näytä tuote');
            			$action.val('show');
            		}
            		submitButton.attr('disabled', false);
            	}
        });
        $('#contentInner').find('.item-'+product_id).hide();
        $.colorbox.close();
    });
}


$(document).ready(function() {

    initialize();

    /* Määritellään elementit */
    var $menuButton = $('#menuButton');
    var $sidebarInner = $('#sidebarInner');
    var $headerMenu = $('#headerMenu');
    var $content = $('#content');
    var $sidebarContent = $('.sidebarContent');
    var $carts = $('.js-render-cart');

    if ($carts.length) {
        for (var i=0;i<$carts.length;i++) {
            var model = $carts[i].getAttribute('data-cart-model');
            if (model) {
                renderCart(model, window.cartObject || []);
            } else {
                console.warn('cart model not found');
            }
        }
    }

    console.log("document ready!");

    /* Delete item from cart */
    $('body').on('submit', 'form.deleteProduct', async (event) => {
        event.preventDefault();

        const form = $(event.target);

        const product_id = form.find('input[name="product_id"]').val();
        const product_title = form.find('input[name="product_title"]').val();
        const product_ean = form.find('input[name="product_ean"]').val();
        const ajaxurl = form.find('input[name="ajaxurl"]').val();

        const url = new URL(ajaxurl, window.location.origin);
        url.searchParams.set('action', 'change');
        url.searchParams.set('product_id', product_id);
        url.searchParams.set('amount', '0');

        showDeletedFromCartToast({ product_title, product_ean });

        try {
            const response = await fetch(url);
            const data = await response.json();
            renderCart('summary', data);
        } catch( error ) {
            console.log(error);
        }

    });


    /* Click header menu */
    $menuButton.click(function(el) {
        $headerMenu.slideToggle(200);
        $menuButton.toggleClass('on');
    })

    /* Clicking the disabled link */
    $('a').on('click', function(event){
        if($(this).hasClass('disabled')) {
            event.preventDefault();
        }
    });

    /* Adding item to cart */
    $('.addItemButton').on('click', function(event) {
        var $form = $(this).closest('form');
        event.preventDefault();

        var product_id = $form.find('input[name="product_id"]').val();
        var product_title = $form.find('input[name="product_title"]').val();
        var product_ean = $form.find('input[name="product_ean"]').val();
        var amount = $form.find('input[name="amount"]').val();
        var recommended_price = $form.find('input[name="recommended_price"]').val();

        if(amount === '') {
            amount = '1'
        }

        showAddedCartToast({ product_title, product_ean, amount, recommended_price });

        if(parseInt(amount) > 0) {
            var ajaxurl = $form.find('input[name="ajaxurl"]').val();
            var product_id_finnsweet = $form.find('input[name="product_id_finnsweet"]').val();

            var submitButton = $form.find('input.button');
            submitButton.attr('disabled', true);
            $('.updatingCart').fadeIn();

            var url = ajaxurl +'?action=add&product_id='+encodeURIComponent(product_id)+
                              '&title='+encodeURIComponent(product_title)+
                              '&ean='+encodeURIComponent(product_ean)+
                              '&amount='+encodeURIComponent(amount)+
                              '&product_id_finnsweet='+encodeURIComponent(product_id_finnsweet)+
                              '&recommended_price='+ encodeURIComponent(recommended_price);

            $.get(url, function(data) {


                renderCart('cartBlock', data);
                renderCart('sideCart', data);

                var updateCart = data[0].products;
                $.each(updateCart, function( key, value ) {
                    var addedItem = updateCart[key].product_id;
                    var addedItemQty = updateCart[key].amount;

                    if(addedItem === product_id) {
                        console.log('Yhteensä: ' + addedItemQty + ' kpl');
                        if(parseFloat(addedItemQty) > limit_units && $.cookie('finnsweet_shop_' + product_id + '_limit_units') != '1') {
                            alert(limit_units_warning);
                            $.cookie('finnsweet_shop_' + product_id + '_limit_units', '1', { expires: 1, path: '/' });
                        }
                    }
                });

                $('.updatingCart').fadeOut();
                submitButton.attr('disabled', false);
            });
        }
    });

    $('#contentInner form.addItem').submit(function(event) {
        //event.preventDefault();
    });

    /* Search customers */
    $('.customerSearch').on('focus', function(event) {
        var $customerSelect = $('.customerSelect');
        $customerSelect.fadeIn(200);
    });
    var timeout;
    $('.customerSearch').on('keyup', function(event) {
        if(timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        timeout = setTimeout(function(event) {
            var $footerInner = $('#footerInner');
            var $customerSelect = $('.customerSelect');

            var searchTerm = $('input[name="customerSearch"]').val();
            var ajaxurl = '/fi/verkkokauppa/ajax-pages/asiakkaat/?id=' + encodeURIComponent(searchTerm);

            $.get(ajaxurl, function(data) {
                $customerSelect.find('ul').replaceWith(data);
            });
        }, 500);
    });

    /* Get customer info by clicking list item */
    $('.customerSelect').on('click', 'li', function(event) {
        event.preventDefault();

        var $customerInfo = $('div.customerInfo');
        var $customerSelect = $('.customerSelect');
        $customerInfo.fadeOut(0);

        var customerName = $(this).data('name');
        var customerId = $(this).data('customer-id');
        var customerAddress = $(this).data('address');

        $customerInfo.find('.name').empty().append(customerName);
        $customerInfo.find('.address').empty().append(customerAddress);

        $('.confirmOrderDiv').find('input[name="customer_id"]').val(customerId);
        $('input.confirmOrder').attr('disabled', false);

        // Set customer to Session
        var ajaxurl = '/fi/verkkokauppa/ajax-pages/set-customer/?customer_id=' + encodeURIComponent(customerId);
        $.get(ajaxurl, function(data) {
            //console.log("Asiakas tallennettu sessioon");
            window.location = '/fi/verkkokauppa/ostoskori/';
        });

        $customerInfo.fadeIn(200);
        $customerSelect.fadeOut(200);

    });

    $('.deleteCustomer').on('click', function(el){
        el.preventDefault();
        var $deleteCustomer = $(this).parent();
        // Set customer to Session
        var ajaxurl = '/fi/verkkokauppa/ajax-pages/set-customer/?customer_id=0';
        $.get(ajaxurl, function(data) {
            $deleteCustomer.html('');

            window.location = '/fi/verkkokauppa/ostoskori/';
        });
    });


    var timeoutOrderCustomerOrderId;
    $('.orderCustomerOrderId').on('keyup', function(event) {
        var value = $(this).val()

        if(timeoutOrderCustomerOrderId) {
            clearTimeout(timeoutOrderCustomerOrderId);
            timeoutOrderCustomerOrderId = null;
        }
        timeoutOrderCustomerOrderId = setTimeout(function(event) {

            if(value.length > 0) {

                var ajaxurl = '/fi/verkkokauppa/ajax-pages/save-order-details/?customerOrderId='+ encodeURIComponent(value);
                $.get(ajaxurl, function(data) {
                    //console.log(data);
                });
            }
        }, 1000);
    });

    var timeoutorderDescription;
    $('.orderDescription').on('keyup', function(event) {
        var $tooLong = $('.tooLong');
        var value = $(this).val()
        if(value.length > 100) {
            $tooLong.css('display', 'inline-block');
            $(this).css('color', 'red');
        } else {
            $tooLong.hide();
            $(this).css('color', '#000');
        }
        if(timeoutorderDescription) {
            clearTimeout(timeoutorderDescription);
            timeoutorderDescription = null;
        }
        timeoutorderDescription = setTimeout(function(event) {

            if(value.length > 0) {
                var ajaxurl = '/fi/verkkokauppa/ajax-pages/save-order-details/?description='+ encodeURIComponent(value);
                $.get(ajaxurl, function(data) {
                    //console.log(data);
                });
            }
        }, 1000);
    });



    /* Select email address */
    $('.copyDraft').find('.emailAddressField').on('focus', function(event) {
        var $emailSelect = $(this).parent().parent().find('.emailSelect');
        $emailSelect.fadeIn(200);
    });
    $('.copyDraft').find('.emailAddressField').on('focusout', function(event) {
        var $emailSelect = $(this).parent().parent().find('.emailSelect');
        $emailSelect.fadeOut(200);
    });

    var timeout2;
    $('.copyDraft').find('.emailAddressField').on('keyup', function(event) {
        var parentElement = $(this).parent().parent();
        if(timeout2) {
            clearTimeout(timeout2);
            timeout2 = null;
        }
        timeout2 = setTimeout(function(event) {
            var $emailSelect = parentElement.find('.emailSelect');

            var userId = parentElement.find('input[name="email"]').data('userid');
            var query = parentElement.find('input[name="email"]').val();
            var ajaxurl = '/fi/verkkokauppa/ajax-pages/ajax-sahkopostit/?id=' + encodeURIComponent(userId) + '&query=' + encodeURIComponent(query);

            $.get(ajaxurl, function(data) {
                $emailSelect.find('ul').replaceWith(data);
            });
        }, 500);
    });

    /* Get customer info by clicking list item */
    $('.emailSelect').on('click', 'li', function(event) {
        event.preventDefault();
        var parentElement = $(this).parent().parent().parent();

        var $emailSelect = $(this).parent().parent();
        var $emailField = parentElement.find('.emailAddressField');
        var $sendField = parentElement.find('.emailPdf');

        var customerEmail = $(this).data('email');

        $emailField.val(customerEmail);
        $sendField.attr('data-email', customerEmail);
        $emailSelect.fadeOut(200);

    });

    /* Send pdf to email / Lähetä tilausvahvistus */
    $('.emailPdf').on('click', function(el) {
        el.preventDefault();

        var $this = $(this);
        var order_id = $(this).data('order-id');
        var ajaxurl = $(this).data('ajaxurl');
        var emailToSend = $this.siblings('[name="email"]').val();
        var userId = $(this).attr('data-userid');
        var sendMail = ajaxurl + '?email='+encodeURIComponent(emailToSend)+'&order_id='+encodeURIComponent(order_id)+'&userid='+encodeURIComponent(userId);

        //console.log("Email to send: " + emailToSend);
        if (emailToSend) {
            $.get(sendMail, function(data) {
                if(data == '1') {
                    $this.siblings('.emailAddressField').val('');
                    $this.attr('data-email', '');
                    $this.parent().siblings('.emailSelect').hide();

                    alert('Sähköposti lähetetty');
                }
            });
        }
    });

    $.fn.textWidth = function(text, font) {
        if (!$.fn.textWidth.fakeEl) $.fn.textWidth.fakeEl = $('<span>').hide().appendTo(document.body);
        $.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css('font', font || this.css('font'));
        return $.fn.textWidth.fakeEl.width();
    };

    function resizeInput() {
        const inputTextWidth = $(this).textWidth($(this).val())
        if(inputTextWidth >= parseInt($(this).css('width')) + 5) {
            $(this).css('width', inputTextWidth + 5 + 'px');
        }
    }

    $('.pdfOfferDescription').on('keyup', resizeInput);

    /* Generate offer PDF */
    $('.pdfOffer').on('click', function(el) {
        el.preventDefault();
        var $this = $(this);
        var orderId = $this.data('order-id');
        var ajaxurl = $this.data('ajaxurl');
        var offerName = $this.parent().find('[name="offer-name"]').val();
        var offerDescription = $this.parent().find('[name="offer-description"]').val();
        var ingredients = $('input[name="'+orderId+'_pdf_offer_ingredients"]:checked').val() || '0';

        const divAlert = $(`
            <div class="alert alert-info py-2 small d-flex align-items-center">
                <strong>PDF tarjous:</strong>
                <a target="_blank"></a>
                <div class="ms-auto spinner-border text-dark" role="status"></div>
            </div>`);

        $this.closest('form').find('.alert').remove();
        $this.closest('form').append(divAlert);

        if (offerName) {
            $this.attr('disabled', true);
            var url = ajaxurl + '?order_id='+encodeURIComponent(orderId)+'&offer_name='+encodeURIComponent(offerName)+'&offer_description='+encodeURIComponent(offerDescription)+'&ingredients='+ingredients;
            $.ajax({
                url: url,
                method: 'GET',
                global: false // disable global ajaxComplete for this
            }).done(function(data) {
                if (data && data.pdf) {
                    $this.closest('form').find('.alert a').text(data.name).attr('href', data.pdf);
                    $this.closest('form').find('.alert .spinner-border').addClass('d-none');
                } else {
                    alert('Tarjouksen luonti epäonnistui. Päivitä sivu ja yritä uudelleen.');
                }
            }).fail(function() {
                alert('Tarjouksen luonti epäonnistui. Päivitä sivu ja yritä uudelleen.');
            })
        }
    });



    /* Save orderPdfInformation / "Saateviesti" */
    $('.copyDraft').on('click', '.savePdfInformation', function(el) {
        el.preventDefault();
        var pdfInformation = $(this).siblings('.orderPdfInformation').val();
        var orderId = $(this).attr('data-orderid');

        if(pdfInformation) {
            var ajaxurl = '/fi/verkkokauppa/ajax-pages/ajax-save-draft-info/?orderid=' + encodeURIComponent(orderId) + '&pdfinformation=' + encodeURIComponent(pdfInformation);
            $.get(ajaxurl, function(data) {
                if(data == '1') {
                    alert('Saateviesti tallennettu');
                }
            });
        }
    });

    $('input.saveOrderCheckbox').removeAttr('checked');
    $('input.saveOrderCheckbox').change(function() {
        var checkboxVal = this.checked
        if(checkboxVal) {
            $('.saveOrderDiv').show();
            $('.placeOrderDiv').hide();
            $('input.saveOrderCheckbox').val('1');
        } else {
            $('.placeOrderDiv').show();
            $('.saveOrderDiv').hide();
            $('input.saveOrderCheckbox').val('0');
        }
    });


    /* Disable "place order" -button if customer not selected*/
    if($('form.placeOrder').find('input[name="customer_id"]').val() == 0) {
        $('input.confirmOrder').attr('disabled', true);
    }


    $('form.placeOrder').submit(function(e) {
        var draft = $('input.saveOrderCheckbox').val();
        console.log('Save as draft: '+draft);
        if(draft == '0') {
            if (!confirm('Haluatko varmasti lähettää tilauksen?')) {
                e.preventDefault();
            } else {
                //e.preventDefault();
                $.each($.cookie(), function(key,value) {
                    if(key.indexOf('finnsweet_shop') > -1) {
                        $.cookie(key, '0', { exprires: 1, path: '/' });
                    }
                });
            }
        } else {
            //e.preventDefault();
        }
    });


    // Write order-description
    $('.orderDescription').focus(function() {
        $(this).css({'height': '200px'});
    });
    $('.orderDescription').focusout(function() {
        $(this).css({'height': 'auto'});
    });

    /* Days between two dates */


    // Initialize datepicker
    $('#datePick').glDatePicker({
        cssName: 'flatwhite',
        onClick: function(target, cell, date, data) {

            var thisVal = date.getDate() + '.' + parseInt(date.getMonth() + 1) + '.' + date.getFullYear();
            var ajaxurl = '/fi/verkkokauppa/ajax-pages/save-order-details/?shippingDate='+ encodeURIComponent(thisVal);
            $.get(ajaxurl, function(data) {
                if(!data.result) {
                    //alert("Päivämäärä")
                }
            });

            target.val(thisVal);

            var today = new Date();
            if(date < today) {
                if(parseInt(today.getDate()) != parseInt(date.getDate())) {
                    alert('Valitsemasi päivämäärä on jo mennyt.');
                    target.val(today.getDate() + '.' + parseInt(today.getMonth() + 1) + '.' + today.getFullYear());
                }
            }

            /* If day limit is exceed */
            var ONE_DAY = 1000 * 60 * 60 * 24;
            var date1_ms = today.getTime()
            var date2_ms = date.getTime()
            var difference_ms = Math.abs(date1_ms - date2_ms)
            var total_days = parseInt(Math.round(difference_ms/ONE_DAY) + 1);

            if(limit_days > 0) {
                if(total_days > limit_days && $.cookie('finnsweet_shop_limit_days') != '1') {
                    alert(limit_days_warning)
                    $.cookie('finnsweet_shop_limit_days', '1', { expires: 1, path: '/' });
                }
            }

            if(data != null) {
                alert(data.message + '\n' + date);
            }
        }
    });

    /*  Load more client page items */
    $('.client-load-more').on('click', function(el) {
        el.preventDefault();
        var $this = $(this);
        $this.attr('disabled', true);

        const target = $this.data('target');

        var $table = $this.closest('table');
        var $loadMoreRow = $this.closest('.load-more-row');
        var totalItems = parseInt($this.data('total')) || false;
        var action = $this.data('action');
        var client = $this.data('client');
        var start = $this.data('start');
        var sort = $this.data('sort');
        var ajaxurl = $this.data('ajaxurl');


        var moreItems = ajaxurl + '?action='+encodeURIComponent(action)+'&client='+encodeURIComponent(client)+'&start='+encodeURIComponent(start);
        if (sort) {
            moreItems += '&sort='+encodeURIComponent(sort);
        }
        $.get(moreItems, function(data) {
            if (data) {
                $loadMoreRow.before(data);
            }

            const itemCount = $table.find('.itemRow').length;
            $this.data('start', itemCount);

            if (totalItems && itemCount >= totalItems) {
                $loadMoreRow.hide();
            }
            $this.attr('disabled', false);
        });
    });

}); // End of document ready function
